<script setup lang="ts">
import { useGetCanvass } from "@/canvasses/canvassesCrud";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import CanvassFlowLayout from "@/layouts/CanvassFlowLayout.vue";
import { RouterView } from "vue-router";

const props = defineProps<{
  canvassId: string;
}>();

const { canvass, getCanvassStatus } = useGetCanvass(props.canvassId);
</script>
<template>
  <CanvassFlowLayout>
    <HandleQueryStatus :query-status="getCanvassStatus">
      <div v-if="canvass !== undefined" class="canvass-flow-shell">
        <div class="canvass-flow-content">
          <RouterView v-slot="{ Component }">
            <KeepAlive include="CanvassAreaPage">
              <component :is="Component" :canvass="canvass"></component>
            </KeepAlive>
          </RouterView>
        </div>
        <RouterView v-slot="{ Component }" name="nav">
          <component :is="Component" :canvass-id="canvassId" />
        </RouterView>
      </div>
    </HandleQueryStatus>
  </CanvassFlowLayout>
</template>

<style scoped>
.canvass-flow-shell {
  --canvass-flow-bottom-nav-height: 4rem;

  block-size: 100dvh;
  display: flex;
  flex-direction: column;

  .canvass-flow-content {
    flex: 1;
    overflow-y: auto;
    padding-block-end: var(--spacing-lg);
  }
}
</style>
